import React from 'react'
import RoutesMenusPrivate from './private'
import RoutesMenusPublic from './public'
// import RoutesMenusDinamic from './dinamic'

export default function RoutesMenus() {
    return (
        <>
            <RoutesMenusPrivate />
            <RoutesMenusPublic />
            {/* <RoutesMenusDinamic /> */}
        </>

    )
}
